export type TrendingStocksPrimaryTab = "stocks" | "fo";
export type TrendingStocksDurationFilter =
  | "all_calls"
  | "short_term"
  | "mid_term"
  | "long_term";
export type TrendingStockTradeAction = "buy" | "sell";
export const TRENDING_STOCKS_PRIMARY_TABS: TrendingStocksPrimaryTab[] = [
  "stocks",
  "fo",
];
export const TRENDING_STOCKS_DURATION_FILTERS: TrendingStocksDurationFilter[] = [
  "all_calls",
  "short_term",
  "mid_term",
  "long_term",
];

export type TrendingStocksEntityMap = Partial<
  Record<
    TrendingStocksPrimaryTab,
    Partial<Record<TrendingStocksDurationFilter, string>>
  >
>;

export interface TrendingStocksFieldLabels {
  gainSoFar?: string;
  buyPrice?: string;
  targetPrice?: string;
  stopLoss?: string;
  potentialReturns?: string;
  noResultsTitle?: string;
  noResultsDescription?: string;
  stockListingAriaLabel?: string;
  addToWatchlistAriaLabel?: string;
}

export interface TrendingStocksWatchlistConfig {
  modalTitle?: string;
  modalBtnCta?: string;
  successMsg?: string;
  errorMsg?: string;
  cta_text?: string;
  section_title?: string;
}

export interface TrendingStocksTradeConfig {
  buyText?: string;
  sellText?: string;
  headerName?: string;
  onboardingUrlWeb?: string;
  onboardingUrlApp?: string;
}

export interface TrendingStocksAemConfig {
  title?: string;
  subtitle?: string;
  infoBanner?: {
    text?: string;
    ctaText?: string;
    ctaUrl?: string;
  };
  // Backward-compatibility with previously authored flat keys.
  infoBannerText?: string;
  infoBannerCtaText?: string;
  infoBannerCtaUrl?: string;
  tabs?: {
    stocks?: string;
    fo?: string;
  };
  durationFilters?: {
    allCalls?: string;
    shortTerm?: string;
    midTerm?: string;
    longTerm?: string;
  };
  fields?: TrendingStocksFieldLabels;
  showMoreText?: string;
  showLessText?: string;
  emptyState?: {
    title?: string;
    description?: string;
    imageSrc?: string;
    imageAlt?: string;
    /**
     * Backward-compatible alias used by some authored JSON payloads.
     * If present, it should be treated same as imageSrc.
     */
    errorImage?: string;
  };
  apiFailingState?: {
    title?: string;
    description?: string;
    retryButtonText?: string;
    errorImage?: string;
    apiFailureImageAlt?: string;
  },
  watchlist?: TrendingStocksWatchlistConfig;
  trade?: TrendingStocksTradeConfig;
  defaultEntity?: string;
  entityMap?: TrendingStocksEntityMap;
  initialExpandedCards?: number;
}

export interface TrendingStocksCardData {
  id: string;
  symbol: string;
  stockName: string;
  exchange: number;
  token: number;
  nseToken: number;
  bseToken: number;
  exchId: string;
  redirectURL: string;
  ltp: string;
  valueChange: string;
  percentageChange: string;
  gainSoFar: string;
  callDateLabel: string;
  callTimeLabel: string;
  callTypeLabel: string;
  callStatusLabel: string;
  callOptionLabel?: string;
  tradeAction?: TrendingStockTradeAction;
  buyPrice?: string;
  targetPrice?: string;
  stopLoss?: string;
  potentialReturns?: string;
  isExpandedDefault?: boolean;
}

export interface TrendingStocksListResult {
  items: TrendingStocksCardData[];
  totalCount: number;
  showMore: boolean;
}

export type TrendingStocksSelectionKey =
  `${TrendingStocksPrimaryTab}:${TrendingStocksDurationFilter}`;

export type TrendingStocksInitialSelections = Partial<
  Record<TrendingStocksSelectionKey, TrendingStocksListResult>
>;

export interface TrendingStocksQueryParams {
  tab: TrendingStocksPrimaryTab;
  duration: TrendingStocksDurationFilter;
  page?: number;
  limit?: number;
  entity?: string;
  initialExpandedCards?: number;
}

export type PageProps = {
  params: Promise<{
    version?: string;
  }>;
  searchParams?: Promise<Record<string, string | string[] | undefined>>;
};
